export enum ImporterMode {
    AUTOMATIC = "automatic",
    WITH_CHOICE = "withChoice",
    WITHOUT_CHOICE = "withoutChoice",
  }
  